var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1NoDoorbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.89 52l19.5-21 4.15 21-4.15-21-19.45 21h-.05zM38 17.17C31.57 17.17 26.17 22 24.88 29l-3.59 18.31 5.23-5.61 2.33-11.9c.93-5 4.7-8.55 9.15-8.55a8.57 8.57 0 015.6 2.13l2.79-3A12.6 12.6 0 0038 17.17zM27.94 52h-.05l19.5-21 4.15 21H27.89h.05zM70.85 0L0 76h5.48l18.64-20H32v1.27A2.72 2.72 0 0034.72 60h6.56A2.72 2.72 0 0044 57.28V56h12.41l-5.28-26.93a16.644 16.644 0 00-.39-1.62L76 0h-5.15z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_No_doorbell.c9c5052a.svg";
export { SvgG1NoDoorbell as ReactComponent };